import RESTAPIConfig from "@/config/RESTAPIConfig";
import {ApiSlice} from "@/store/ApiSlice";

const restApiConfig = new RESTAPIConfig();

export interface CountWaitingVisitDateResponseInterface {
    count: number
}

export const CountWaitingVisitDate = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        getCountWaitingVisitDate: builder.query<CountWaitingVisitDateResponseInterface, void>({
            query: () => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.countWaitingVisitDate(),
            }),
            providesTags: () => ["CountWaitingVisitDate", "FetchedData"],
        })
    })
});

export const {useGetCountWaitingVisitDateQuery} = CountWaitingVisitDate;
